import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import SoftProductTable from './SoftProductTable';
import HardProductTable from './HardProductTable';
import IntellectualPropertyTable from './IntellectualPropertyTable';
import TrainingResultTable from './TrainingResultTable';
import TransferTechnologyTable from './TransferTechnologyTable';
import ScientificPublicationTable from './ScientificPublicationTable';

export default function Product({
  disabled,
  researchKpis,
  researchKpiGroups,
  control,
  errors,
  projectCode,
  handleDownloadFile,
  setProductFilesDelete,
  setTransferredTechnologyFilesDelete,
}) {
  const { t } = useTranslation();
  return (
    <>
      <SoftProductTable
        disabled={disabled}
        control={control}
        errors={errors}
        projectCode={projectCode}
        handleDownloadFile={handleDownloadFile}
        setProductFilesDelete={setProductFilesDelete}
      />
      <HardProductTable
        disabled={disabled}
        control={control}
        errors={errors}
        researchKpis={researchKpis}
        researchKpiGroups={researchKpiGroups}
        projectCode={projectCode}
        handleDownloadFile={handleDownloadFile}
        setProductFilesDelete={setProductFilesDelete}
      />
      <h4 className="mt-1">{t('r05.b.b2.no1')}</h4>
      <ScientificPublicationTable
        disabled={disabled}
        control={control}
        errors={errors}
        researchKpis={researchKpis}
        researchKpiGroups={researchKpiGroups}
        projectCode={projectCode}
        handleDownloadFile={handleDownloadFile}
        setProductFilesDelete={setProductFilesDelete}
      />
      <IntellectualPropertyTable
        disabled={disabled}
        researchKpis={researchKpis}
        researchKpiGroups={researchKpiGroups}
        control={control}
        errors={errors}
        projectCode={projectCode}
        handleDownloadFile={handleDownloadFile}
        setProductFilesDelete={setProductFilesDelete}
      />
      <TransferTechnologyTable
        disabled={disabled}
        researchKpis={researchKpis}
        researchKpiGroups={researchKpiGroups}
        control={control}
        errors={errors}
        projectCode={projectCode}
        handleDownloadFile={handleDownloadFile}
        setTransferredTechnologyFilesDelete={setTransferredTechnologyFilesDelete}
      />
      <TrainingResultTable
        disabled={disabled}
        researchKpis={researchKpis}
        researchKpiGroups={researchKpiGroups}
        control={control}
        errors={errors}
        projectCode={projectCode}
        handleDownloadFile={handleDownloadFile}
        setProductFilesDelete={setProductFilesDelete}
      />
    </>
  );
}

Product.propTypes = {
  disabled: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  researchKpis: PropTypes.array,
  // eslint-disable-next-line react/forbid-prop-types
  researchKpiGroups: PropTypes.array,
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  projectCode: PropTypes.string.isRequired,
  handleDownloadFile: PropTypes.func,
  setProductFilesDelete: PropTypes.func,
  setTransferredTechnologyFilesDelete: PropTypes.func,
};

Product.defaultProps = {
  disabled: false,
  researchKpis: [],
  researchKpiGroups: [],
  handleDownloadFile: () => null,
  setProductFilesDelete: () => null,
  setTransferredTechnologyFilesDelete: () => null,
};
